<template>
  <div>
    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue"
      style="background-image:url('assets/img/layout/bg_serg.jpg');"
    >
      <div class="popup_close close-animate">
        <a @click="goBackRoute"><CloseSvg /></a>
      </div>
      <a class="no_mobile link_goback" @click="goBackRoute">
        חזרה <ArrowBack />
      </a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold">יצירת ניתוח לשיבוץ -</span>{{ activeDoctor.name }}
        </h1>
        <div class="add_step_all flex flex--content--center no_mobile">
          <div class="add_step active">1</div>
          <div class="add_step">2</div>
          <div class="add_step">3</div>
          <div class="add_step">4</div>
        </div>
      </div>
    </section>
    <section class="add_new_main">
      <div class="add_st1" style="display:block">
        <div class="subtitle center">
          ליצירת ניתוח אנא הזינו תעודת זהות
        </div>
        <validation-observer ref="createAppForm">
          <form
            @submit.prevent="sendForm"
            v-promise-btn="{ action: 'submit' }"
            autocomplete="off"
          >
            <div class="w-570">
              <div class="form_input input-38">
                <label>ת.ז*</label
                ><validation-provider
                  :rules="{ required: true, israeliId: [isDarcon] }"
                  name="passport"
                  v-slot="{ errors }"
                >
                  <input
                    name="passport"
                    v-model="passport"
                    v-mask="isDarcon ? 'X'.repeat(100) : ['####', '#########']"
                    type="tel"
                    autocomplete="off"
                  />
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>

              <div class="add_new_row flex desk-flex">
                <div class="form_check form_check-black">
                  <label>
                    <input type="checkbox" v-model="isDarcon" />
                    דרכון
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div
                class="form_submit center "
                :class="{ bt_disable: notValid }"
              >
                <button type="submit" class="bt_blue">הבא</button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
    <div v-if="false">
      <!-- page-add-block-serg -->
      <div class="page-add-block-serg">
        <section
          class="add_new_head add_new_head-h white--body tx--bege relative cover m_bg_blue-serg"
        >
          <div class="popup_close close-animate">
            <router-link to="/dashboard"><CloseSvg /></router-link>
          </div>
          <a class="no_mobile link_goback cursor-p" @click="$router.go(-1)">
            חזרה
            <ArrowBackSvg
          /></a>
          <div class="inner_width flex flex--column center">
            <h1 class="title">
              <span class="bold">הזמנת בלוק לחדר ניתוח</span>
              {{ activeDoctor.name }}
            </h1>
          </div>
        </section>
        <section class="page-edit-padd bg--white">
          <div class="subtitle center">
            טקסט עזרה לורם א׳קקריפסום דולור סיט איפסום דולור טיס לולכרם איפסום
            דולור
          </div>
          <div class="filter_select">
            <select>
              <option>סוג בלוק</option>
              <option>סוג בלוק</option>
              <option>סוג בלוק</option>
            </select>
          </div>
          <div class="input-block-serg">
            <input type="text" class="datepicker" name="" placeholder="תאריך" />
          </div>
          <div class="choose-room border-top">
            <div class="text center">בחירת חדר ניתוח פנוי</div>
            <div class="all-rooms flex">
              <div class="room-choise bg--bege ease">
                <b>חדר ניתוח 1</b>11:00-16:30
              </div>
              <div class="room-choise bg--bege ease">
                <b>חדר ניתוח 2</b>11:00-16:30
              </div>
              <div class="room-choise bg--bege ease">
                <b>חדר ניתוח 3</b>11:00-16:30
              </div>
            </div>
            <!-- end all-rooms-->
            <div class="center">
              <a class="bt_blue bt_border" href="javascript:void(0);"
                >הצג עוד</a
              >
            </div>

            <!-- after-choose-room-->
            <div class="after-choose-room">
              <div class="room-choise bg--bege ease">
                <b>חדר ניתוח 3</b>11:00-16:30
                <div class="tx--blue">עריכה</div>
              </div>
            </div>
          </div>
          <!-- end choose-room -->

          <div class="choose-room-time border-top">
            <div class="text center let-1 mb-15">
              ניתן לערוך את שעת ההתחלה והסיום מתוך חלון הזמנים שנבחר
            </div>
            <div class="page-edit-row flex">
              <div>שעת התחלה</div>
              <div class="form_input">
                <input type="tel" value="08:00" />
              </div>
            </div>
            <div class="page-edit-row flex">
              <div>שעת סיום</div>
              <div class="form_input">
                <input type="tel" value="20:00" />
              </div>
            </div>
          </div>
          <!-- end choose-room-time -->
          <button class="bt_blue w-100 bt_disable mt-40">שמירה</button>
        </section>
      </div>
      <!-- end page-add-block-serg -->

      <!-- pop-approve-serg -->
      <div class="popup_in">
        <div class="popup pop-delete-block">
          <div class="title bold">
            הבלוק שוריין לבקשתך ויאושר סופית ע״י צוות מוקד הניתוחים תוך יום
            עבודה אחד
          </div>
          <a class="bt_blue bt-approveDelete w-100" href="">סגור</a>
        </div>
      </div>
      <!-- End pop-approve-serg -->
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../../assets/img/svg/close.svg";
import ArrowBack from "../../../assets/img/svg/arrow_r.svg";
import ArrowBackSvg from "../../../assets/img/svg/arrow_r.svg";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import { getHash } from "../../../utilities/hash.js";

export default {
  name: "AddNewSurgery",
  data() {
    return {
      isDarcon: false,
      doctorName: "",
      passport: ""
    };
  },
  mounted() {
    let doc = this.doctors.find(d => d.id == this.activeDoctor);
    if (typeof doc != "undefined") {
      this.doctorName = doc.name;
    }
  },
  computed: {
    ...mapGetters(["activeDoctor", "doctors"]),
    notValid() {
      if (!this.passport) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["SET_PASSPORT"]),
    ...mapActions(["SET_SURGERY_PATIENT"]),
    sendForm() {
      return new Promise(resolve => {
        this.$refs.createAppForm.validate().then(res => {
          if (res) {
            this.$API
              .validatePassport(this.passport)
              .then(res => {
                const passport_type = this.isDarcon ? "foreign" : "israeli";
                if (res.status == "ERROR") {
                  this.SET_SURGERY_PATIENT({
                    apotropos: "",
                    birth_date: "",
                    first_name: "",
                    gender: "",
                    id_num: this.passport,
                    last_name: "",
                    phone: "",
                    second_phone: "",
                    status: "",
                    passport_type
                  });
                } else {
                  this.SET_SURGERY_PATIENT({ ...res, passport_type });
                }
                // this.SET_PASSPORT(res.id_num);

                resolve();
                this.$router.push({ name: "surg-add-info" });
              })
              .catch(e => {
                this.$modal.show(Error);
              });
          } else {
            resolve();
          }
        });
      });
    },
    goBackRoute() {
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.go(-1);
        return;
      }
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    }
  },
  watch: {
    isDarcon() {
      this.passport = "";
    }
  },
  components: {
    CloseSvg,
    ArrowBack,
    ArrowBackSvg
  }
};
</script>
